import React from 'react';
import { Table } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';

const EstadosSubestadosTable = React.memo(({ estados, canAdmin }) => {
  // Tabla con rowSpan (sin columna descripción de estado)
  const renderTable = () => {
    if (!estados.length || !estados[0].estados?.length) {
      return <tr><td colSpan={4} className="text-center">No hay estados ni subestados para este tipo.</td></tr>;
    }
    const rows = [];
    estados[0].estados.forEach((estado) => {
      const subestados = estado.sub_estados && estado.sub_estados.length > 0 ? estado.sub_estados : [null];
      subestados.forEach((subEstado, idx) => {
        rows.push(
          <tr key={estado.id + '-' + (subEstado?.id || idx)}>
            {idx === 0 && (
              <td rowSpan={subestados.length} style={{ verticalAlign: 'middle', fontWeight: 500 }}>{estado.estado}</td>
            )}
            <td>{subEstado ? subEstado.sub_estado : <span className="text-muted">Sin subestados</span>}</td>
            <td>{subEstado ? subEstado.descripcion : '-'}</td>
            <td>
              {subEstado && canAdmin && (
                <>
                  <FaEdit style={{ cursor: 'pointer', color: '#007bff', marginRight: 10 }} title="Editar" />
                  <FaTrash style={{ cursor: 'pointer', color: '#dc3545' }} title="Eliminar" />
                </>
              )}
            </td>
          </tr>
        );
      });
    });
    return rows;
  };

  return (
    <div className="table-responsive">
      <Table bordered hover size="sm" className="align-middle">
        <thead className="table-light">
          <tr>
            <th>Estado</th>
            <th>Subestado</th>
            <th>Descripción Subestado</th>
            <th style={{ width: 90 }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {renderTable()}
        </tbody>
      </Table>
    </div>
  );
});

export default EstadosSubestadosTable;
